import { render, staticRenderFns } from "./ncalayer.vue?vue&type=template&id=cb2a56b8&"
import script from "./ncalayer.vue?vue&type=script&lang=ts&"
export * from "./ncalayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports